import { ethers } from "ethers";

// ─── Nibiru EVM ─────────────────────────────────────────────────
export const NIBIRU_EVM_CHAIN_ID = parseInt(
  process.env.REACT_APP_NIBIRU_EVM_CHAIN_ID || "0x1AF4",
  16
);
export const NIBIRU_HEX_CHAIN_ID =
  process.env.REACT_APP_NIBIRU_EVM_CHAIN_ID || "0x1AF4";
export const NIBIRU_EVM_RPC =
  process.env.REACT_APP_NIBIRU_EVM_RPC || "https://evm-rpc.nibiru.fi";
export const NIBIRU_WALLET_RPC = "https://evm-rpc.nibiru.fi";
export const NIBIRU_USDC_ADDRESS =
  process.env.REACT_APP_NIBIRU_USDC_CONTRACT_ADDRESS ||
  "0x0829F361A05D993d5CEb035cA6DF3446b060970b";
export const NIBIRU_USDC_ADAPTER = "0x12a272A581feE5577A5dFa371afEB4b2F3a8C2F8";
export const NIBIRU_EID = 30369;

// ─── LayerZero constants ────────────────────────────────────────
export const NATIVE_DROP_NIBI_AMOUNT = ethers.parseEther("1");
export const MIN_AMOUNT_SLIPPAGE = ethers.toBigInt(5000);
export const OFT_SLIPPAGE_BPS = ethers.toBigInt(100);
export const FEE_MICRO_UNIT = ethers.parseEther("0.000001");
export const USDC_DECIMALS = 6;

// ─── Icons ──────────────────────────────────────────────────────
export const USDC_ICON = "https://app.sai.fun/bridge/usdc.svg";

// ─── Supported bridge chains ───────────────────────────────────
export const BRIDGE_CHAINS = [
  {
    id: "ethereum",
    name: "Ethereum",
    chainId: 1,
    hexChainId: "0x1",
    eid: 30101,
    usdcAddress: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    oftAdapter: "0xc026395860Db2d07ee33e05fE50ed7bD583189C7",
    rpcUrl: "https://ethereum-rpc.publicnode.com",
    explorerUrl: "https://etherscan.io",
    nativeSymbol: "ETH",
    icon: "https://app.sai.fun/bridge/eth.svg",
  },
  {
    id: "arbitrum",
    name: "Arbitrum",
    chainId: 42161,
    hexChainId: "0xA4B1",
    eid: 30110,
    usdcAddress: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    oftAdapter: "0xe8CDF27AcD73a434D661C84887215F7598e7d0d3",
    rpcUrl: "https://arbitrum-one-rpc.publicnode.com",
    explorerUrl: "https://arbiscan.io",
    nativeSymbol: "ETH",
    icon: "https://app.sai.fun/bridge/arbitrum.svg",
  },
  {
    id: "polygon",
    name: "Polygon",
    chainId: 137,
    hexChainId: "0x89",
    eid: 30109,
    usdcAddress: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
    oftAdapter: "0x9Aa02D4Fae7F58b8E8f34c66E756cC734DAc7fe4",
    rpcUrl: "https://polygon-bor-rpc.publicnode.com",
    explorerUrl: "https://polygonscan.com",
    nativeSymbol: "POL",
    icon: "https://app.sai.fun/bridge/polygon.svg",
  },
  {
    id: "base",
    name: "Base",
    chainId: 8453,
    hexChainId: "0x2105",
    eid: 30184,
    usdcAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    oftAdapter: "0x27a16dc786820B16E5c9028b75B99F6f604b5d26",
    rpcUrl: "https://base-rpc.publicnode.com",
    explorerUrl: "https://basescan.org",
    nativeSymbol: "ETH",
    icon: "https://app.sai.fun/bridge/base.svg",
  },
  {
    id: "optimism",
    name: "OP Mainnet",
    chainId: 10,
    hexChainId: "0xA",
    eid: 30111,
    usdcAddress: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
    oftAdapter: "0xcE8CcA271Ebc0533920C83d39F417ED6A0abB7D0",
    rpcUrl: "https://optimism-rpc.publicnode.com",
    explorerUrl: "https://optimistic.etherscan.io",
    nativeSymbol: "ETH",
    icon: "https://assets.coingecko.com/coins/images/25244/standard/Optimism.png",
  },
  {
    id: "bsc",
    name: "BNB Chain",
    chainId: 56,
    hexChainId: "0x38",
    eid: 30102,
    usdcAddress: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
    usdcDecimals: 18, // BSC USDC is 18 decimals (Binance-pegged)
    oftAdapter: "0x962Bd449E630b0d928f308Ce63f1A21F02576057",
    rpcUrl: "https://bsc-rpc.publicnode.com",
    explorerUrl: "https://bscscan.com",
    nativeSymbol: "BNB",
    icon: "https://assets.coingecko.com/coins/images/825/standard/bnb-icon2_2x.png",
  },
];

// ─── ABIs ───────────────────────────────────────────────────────
export const ERC20_ABI = [
  "function approve(address,uint256) returns (bool)",
  "function allowance(address,address) view returns (uint256)",
  "function balanceOf(address owner) view returns (uint256)",
];

export const OFT_ABI = [
  "function quoteSend((uint32,bytes32,uint256,uint256,bytes,bytes,bytes),bool) view returns (uint256 nativeFee,uint256 lzTokenFee)",
  "function quoteOFT((uint32,bytes32,uint256,uint256,bytes,bytes,bytes)) view returns ((uint256 minAmountLD,uint256 maxAmountLD),(int256 feeAmountLD,string description)[],(uint256 amountSentLD,uint256 amountReceivedLD))",
  "function send((uint32,bytes32,uint256,uint256,bytes,bytes,bytes),(uint256 nativeFee,uint256 lzTokenFee),address) payable returns (bytes32 guid,uint64 nonce,(uint256 nativeFee,uint256 lzTokenFee) fee,(uint256 amountSentLD,uint256 amountReceivedLD) oftReceipt)",
];

// ─── Helpers ────────────────────────────────────────────────────

/** Round fee up to nearest micro-unit, then add 5% buffer */
export function ceilFee(rawFee) {
  const remainder = rawFee % FEE_MICRO_UNIT;
  return remainder === ethers.toBigInt(0)
    ? rawFee
    : rawFee + FEE_MICRO_UNIT - remainder;
}

export function execFee(rawFee) {
  return (ceilFee(rawFee) * ethers.toBigInt(105)) / ethers.toBigInt(100);
}

/** Fallback minAmountLD when quoteOFT fails */
export function calcMinAmountLD(tokensToSend) {
  return tokensToSend > MIN_AMOUNT_SLIPPAGE
    ? tokensToSend - MIN_AMOUNT_SLIPPAGE
    : ethers.toBigInt(0);
}

/** Build the OFT sendParam tuple */
export function buildSendParam(dstEid, recipientBytes32, tokensToSend, minAmountLD, options) {
  return [dstEid, recipientBytes32, tokensToSend, minAmountLD, options, "0x", "0x"];
}
